export enum RedesignedTrackComparison {
  Hidden = "hidden",
  Static = "static",
  Tabbed = "tabbed",
}
